import { isNumber } from 'lodash';
import remove from 'lodash/remove';

const validators = {
  required(value) {
    if (Array.isArray(value)) {
      return value && !!value.length;
    }
    if (value === undefined || value === '') {
      return false;
    }
    return true;
  },
  length(value, range) {
    const len = Array.isArray(value) ? value.length : value.toString().length;
    let min = range[0] && range[0] !== 0 ? len >= range[0] : true;
    let max = range[1] && range[1] !== 0 ? len <= range[1] : true;
    return min && max;
  },
  phone(value) {
    const reg = /^1[3-9]\d{9}$/;
    return reg.test(value);
  },
  email(value) {
    const reg =
      /[\w!#$ %& '*+/=?^_`{|}~-]+(?:\.[\w!#$%&' * +/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
    return reg.test(value);
  },
  id(value) {
    const reg = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
    return reg.test(value);
  },
  url(value) {
    const reg = /[a-zA-z]+:\/\/[^\s]*/;
    return reg.test(value);
  }
};

export default function (value, rule, data) {
  if (rule.required) {
    return validators.required(value);
  }
  if (rule.length) {
    return validators.length(value, rule.length);
  }

  if (rule.type && Object.keys(validators).indexOf(rule.type) >= 0) {
    if (!value && value !== 0) {
      return true;
    }
    return validators[rule.type](value);
  }

  // 验证函数
  if (rule.fn) {
    return rule.fn(value, data);
  }

  // 正则
  if (rule.reg) {
    return rule.reg.test(value);
  }

  return true;
}

export class Collector {
  // 元素集合
  list = [];

  // 错误信息
  msg = '';

  add(item) {
    this.list.push(item);
  }

  remove(item) {
    remove(this.list, item);
  }

  clear() {
    this.list = [];
  }

  validate() {
    this.setMessage('');
    const failed = this.list.some(item => !item.validate());
    return !failed;
  }

  reset() {
    this.list.forEach(item => item.reset());
  }

  setMessage(msg) {
    this.msg = msg;
  }

  getMessage() {
    return this.msg;
  }

  getValue() {
    const result = {};
    this.list.forEach(item => {
      const field = item.field;
      const value = item.state.value;

      result[field] = value;
    });

    return result;
  }
}
